import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_deal-tracker-375/artifacts/tdu0tggt_Cinthamani%20Computer%20Logo.png";

export default function Logo({ className = "", invert = false, size = 36 }) {
  // The original logo is black background + blue lines. For the white sidebar we
  // render the image normally; for the dark login panel we keep it as-is.
  return (
    <img
      src={LOGO_URL}
      alt="Cinthamani Computer"
      style={{
        height: size,
        width: "auto",
        filter: invert ? "invert(1) hue-rotate(180deg)" : undefined,
      }}
      className={className}
      data-testid="cinthamani-logo"
    />
  );
}
